module.exports = __webpack_public_path__ + "img/fruit-mangoes-350x184.87a8df26.jpg";